<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    width="880" height="620px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text v-bind="attrs" v-on="on" :disabled="!btnDisabledNewDelete" @click=initData() class="btn">{{$t('Add')}}</v-btn>
    </template>
    <v-card class="popup add_store_popup">
      <v-card-title>
        <h3 class="page-title-bar"><i class="ico ico-user"></i>{{$t('New User')}}</h3>
      </v-card-title>
      <v-card-text>
      <div>
        <v-row>
          <v-col>
            <v-text-field outlined dense hide-details
              :label="`${$t('User ID')} *`"
              :placeholder="$t('Input the ID')"
              class="form-input"
              v-model="account"
              clearable
                @keypress="handleKeyUp"
                @keydown.space.prevent
               @keydown="clearTabindex"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field outlined dense hide-details
              :label="`${$t('Password')} *`"
              :placeholder="$t('Input the password')"
              type="password"
              class="form-input"
              :maxlength="max"
              v-model="password"
              @input="passwordValidate"
              clearable
               @keydown="clearTabindex"
            ></v-text-field>
          </v-col>
        </v-row>

         <div v-if="passwordPolicy">
          <br>
        <span style="color: #001e38;font-size:14px">Password Rules <span style="color: red;">*</span></span>
            <v-row style="margin-top: 5px;">
              <v-col class="cols-6">
                <span class="popup-titbox mb-0" style="display: flex;flex-direction: column;">
                  <p class="frmValidation"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_length, iconClass: has_length }">mdi-checkbox-marked-circle</v-icon>Contains
                    8 to 15 characters.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_uppercase, iconClass: has_uppercase }">mdi-checkbox-marked-circle</v-icon>Include
                    at least 1 uppercase letter.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_lowercase, iconClass: has_lowercase }">mdi-checkbox-marked-circle</v-icon>Include
                    at least 1 lower case letter.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_number, iconClass: has_number }">mdi-checkbox-marked-circle</v-icon>Include
                    at least 1 number.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: has_userid, iconClass: !has_userid }">mdi-checkbox-marked-circle</v-icon>Password
                    should not contains the user_id</p>
                </span>
              </v-col>
              <v-col grow>
                <p class="frmValidation"><v-icon class="mr-4"
                    :class="{ iconClassNot: !has_special, iconClass: has_special }">mdi-checkbox-marked-circle</v-icon>Include
                  at least 1 special character.<br />
                  <span style="font-size: 14px;margin-left: 34px;">(*List all special characters and not just
                    etc)</span>
                </p>
                <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: has_consicutive, iconClass: !has_consicutive }">mdi-checkbox-marked-circle</v-icon>Not
                  use 3 consecutive characters. (abc, 123)</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: has_consecutive_keyboard, iconClass: !has_consecutive_keyboard }">mdi-checkbox-marked-circle</v-icon>Not
                  use 3 consecutive keyboard characters. (qwe, !23)</p>
                <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: has_repeat, iconClass: !has_repeat }">mdi-checkbox-marked-circle</v-icon>Not
                  repeat 3 characters. (aaa, 777)</p>
                <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: !has_space, iconClass: has_space }">mdi-checkbox-marked-circle</v-icon>Not
                  use
                  space.</p>
              </v-col>
            </v-row>
          </div>
        <v-row>
          <v-col>
            <p class="label-txt">{{$t('User Level')}} *</p>
            <v-radio-group
              v-model="accessLevel"
              dense
              hide-details
              row>
              <div v-for="item in accessLevelItems" v-bind:key="item.level">
                <v-radio style="margin-right: 15px; padding:8px"
                  v-if="item.level === '1'"
                  :key="item.level"
                  :label="item.name"
                  :value="item.level"
                  class="form-radio flat"
                  disabled
                ></v-radio>
                <v-radio
                  v-else-if="userAccessLevel > item.level"
                  :key="item.level"
                  style="padding:8px"
                  :label="item.name"
                  :value="item.level"
                  class="form-radio flat"
                  disabled
                ></v-radio>
                <v-radio
                  v-else-if="userAccessLevel <= item.level"
                  :key="item.level"
                  :label="item.name"
                  :value="item.level"
                   style="padding:8px"
                  class="form-radio flat"
                ></v-radio>
              </div>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
      <div>
        <v-row>
          <v-col cols="6">
            <v-text-field outlined dense hide-details
              :label="`${$t('Name')} *`"
              :placeholder="`${$t('Input the name')}`"
              class="form-input"
              v-model="name"
              clearable
               @keydown="clearTabindex"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="`${$t('Email Address')} *`"
              :placeholder="$t('Input the email address')"
              class="form-input"
              v-model="email"
              clearable
               @keydown="clearTabindex"
              outlined dense hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      </v-card-text>
      <div>
        <v-card-actions class="d-flex justify-center">
          <v-btn v-if="passwordPolicy" text icon @click="clickSave" :disabled='!savebutton' class="btn">{{ $t('Save') }}</v-btn>
          <v-btn v-if="!passwordPolicy" text icon @click="clickSave" class="btn">{{ $t('Save') }}</v-btn>
          <v-btn text icon @click="dialog = false" class="btn">{{ $t('Cancel') }}</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import EventBus from '@/plugins/eventBus'
import { getPasswordValidation, getEmailValidation } from '@/plugins/passwordValidator'
import commons from '@/plugins/commons'

export default {
  props: [
    'accessLevelItems',
    'userAccessLevel',
    'btnDisabledNewDelete'
  ],

  data () {
    return {
      dialog: false,
      user: null,
      account: null,
      password: null,
      name: null,
      accessLevel: null,
      email: null,
      emailReport: null,
      emailAlarm: null,
      phoneNumber: null,
      max: 20,
      // Password Rules
      dialog_passwordChange: false,
      confirmpassword: '',
      has_length: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      has_consicutive: false,
      has_consecutive_keyboard: false,
      has_repeat: false,
      has_space: true,
      has_userid: false,
      savebutton: false,
      passwordPolicy: false
      // end
    }
  },
  methods: {
    handleKeyUp (e) {
      commons.specialCharRest(e)
    },
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    isBodyValid (body) {
      for (const key of Object.keys(body)) {
        if (body[key] === null || body[key] === undefined || body[key].length < 1) {
          return false
        }
      }
      return true
    },
    isValidUserInfo (body) {
      const bodyToTest = {
        account: this.account,
        password: this.password,
        firstName: this.name,
        accessLevel: this.accessLevel,
        emailAddress: this.email
      }
      if (!this.isBodyValid(bodyToTest)) {
        EventBus.$emit('messageAlert', this.$t('The user information is invalid.'))
        return false
      }
      const passwordValidation = getPasswordValidation(body.account, body.password, this.user)
      if (!passwordValidation.result) {
        EventBus.$emit('messageAlert', this.$t(passwordValidation.msg))
        return false
      }
      const emailValidation = getEmailValidation(body.emailAddress)
      if (!emailValidation.result) {
        EventBus.$emit('messageAlert', this.$t(emailValidation.msg))
        return false
      }
      return true
    },
    clickSave () {
      const url = '/api/common/account'
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          myAccessLevel: this.userAccessLevel
        }
      }
      const body = {
        account: this.account,
        password: this.password,
        firstName: this.name,
        accessLevel: this.accessLevel,
        emailAddress: this.email
      }
      if (!this.isValidUserInfo(body)) return
      this.$utils.callAxiosWithBody('post', url, body, config)
        .then(res => {
          console.log(res.data)
          EventBus.$emit('messageAlert', this.$t('User' + ' ' + this.account + ' ' + 'successfully created'))
          this.dialog = false
        })
        .catch(error => {
          EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
          this.dialog = true
        })
        .finally(() => {
          this.$emit('updateUserInfo')
          // this.dialog = false
        })
    },
    initData () {
      this.account = null
      this.password = null
      this.name = null
      this.accessLevel = null
      this.email = null
      this.emailReport = null
      this.emailAlarm = null
      this.phoneNumber = null
    },
    passwordValidate () {
      // Length 8 to 15
      if (this.password.length > 7 && this.password.length < 16 && this.password.length !== 0) {
        this.has_length = true
      } else {
        this.has_length = false
      }
      // Upper Case
      this.has_uppercase = /[A-Z]/.test(this.password)

      // Lower Case
      this.has_lowercase = /[a-z]/.test(this.password)

      // One Number
      this.has_number = /\d/.test(this.password)

      // Special Characters
      // eslint-disable-next-line
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password)

      // Consective Characters
      this.has_consicutive = /(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|012|123|234|345|456|567|678|789)/.test(this.password)

      // Consecutive Keyboard Characters Sequences
      this.has_consecutive_keyboard = /(qwe|wert|ert|rty|tyu|yui|uio|iop|asd|sdf|dfg|fgh|ghj|hjk|jkl|zxc|xcv|cvb|vbn|bnm|!23|@#4|$%5|^&6)/.test(this.password)
      // Repeat
      this.has_repeat = /(.)\1\1/.test(this.password)

      // Space
      this.has_space = /^\S+$/.test(this.password)

      // User Id
      this.has_userid = this.password.toLowerCase().includes(this.account.toLowerCase())
      if (this.has_length && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special && !this.has_consicutive && !this.has_consecutive_keyboard && !this.has_repeat && this.has_space && !this.has_userid) {
        this.savebutton = true
      } else {
        this.savebutton = false
      }
    }
  },
  mounted () {
    this.user = this.$store.state.auth.user
    console.log(this.user)
    if (this.$store.state.auth.user.pwPolicyEnable === 'true') {
      this.passwordPolicy = true
    }
  },
  watch: {
    dialog: function () {
      this.initData()
    }
  }
}
</script>
<style scoped>
/* Scroll bar stylings */
::v-deep ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* Track */
  ::v-deep ::-webkit-scrollbar-track {
    background: var(--lightestgrey);
  }

  /* Handle */
  ::v-deep ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
  }

  /* Handle on hover */
  ::v-deep ::-webkit-scrollbar-thumb:hover {
    background: #c1c1c1;
  }
  ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
    }
    .iconClassNot {
  color: lightgrey !important;
}

.iconClass {
  color: #6D9852 !important;
}

.frmValidation {
  font-size: 12px;
}
</style>
